// @flow

import * as React from 'react';
import styles from './BubbleRating.css';

// eslint does not recognize that BubbleRating uses the style classes created on the fly.
/* eslint css-modules/no-unused-class: [2,
  { markAsUsed:
    ['bubble_00', 'bubble_0', 'bubble_05', 'bubble_1', 'bubble_10', 'bubble_15', 'bubble_2', 'bubble_20', 'bubble_25',
     'bubble_3', 'bubble_30', 'bubble_35', 'bubble_4', 'bubble_40', 'bubble_45','bubble_5', 'bubble_50',
      'star_05',  'star_1', 'star_10', 'star_15',  'star_2', 'star_20', 'star_25', 'star_3', 'star_30', 'star_35',
      'star_4', 'star_40', 'star_45', 'star_5', 'star_50']
  }]
*/

type Props = {|
  /** The rating number given as float less in range between 0 and 5, any other values are not valid */
  rating: number,

  /** Optional size of bubble rating, setting font-size */
  fontSize?: number,

  /** styles of bubble rating */
  verticalAlign: ?string,

  /** use stars instead of bubbles, ie. for affiliate reviews */
  useAffiliateStars: boolean,
|};

/**
 * A util function to go from a float rating to an int for the BubbleRating component
 */
const bubbleRatingToInt = (rating: number) => Math.round(rating * 2) * 5;

/**
 * A function to go from a rating int to a correctly padded rating string
 */
const intRatingToString = (rating: number) => (rating === 5 ? '05' : `${rating}`);

/**
 * A Bubble rating component
 */
const BubbleRating = ({ rating, verticalAlign, useAffiliateStars, fontSize }: Props) => {
  const bubbleRating = bubbleRatingToInt(rating);
  const sRating = bubbleRating >= 0 && bubbleRating <= 50 ? intRatingToString(bubbleRating) : '0';
  const bubbleClassName = `bubble_${sRating}`;
  const starClassName = `star_${sRating}`;
  const additionalStyles = {};

  if (verticalAlign) {
    additionalStyles.verticalAlign = verticalAlign;
  }
  if (fontSize) {
    additionalStyles.fontSize = `${fontSize}px`;
  }

  const classRating = useAffiliateStars
    ? `${styles.starRating} ${styles[starClassName]}`
    : `${styles.bubbleRating} ${styles[bubbleClassName]}`;

  return <span className={classRating} style={additionalStyles} />;
};

BubbleRating.defaultProps = { verticalAlign: null, useAffiliateStars: false };

export default BubbleRating;
